//---- components ---------
//---- mixins -------------
//---- services -----------
import { ajaxService } from '@/app/services';
//---- other --------------
import store from '@/app/store/index.js'
import URL from '../common/URL.js';
//---- 3rd-parties --------

//--------------------- DSDashboardService  -------------------------------------
class DSDashboardService {
  getDSDashboardInit() {
    return ajaxService.get(URL.dsDashBoardInitUrl);
  }
  getDSRepairHistoryInit() {
    return ajaxService.get(URL.dsHistoryInitUrl);
  }
  getRepairHistorySessionsData(reqParams) {
    return ajaxService.postData(URL.dsHistoryDefaultUrl, reqParams);
  }
  getDSSearch() {
    return ajaxService.get(URL.searchUrl);
  }
  getSessionsData(pageInfo) {
    return ajaxService.postData(URL.myDSIDsDefaultUrl, pageInfo);
  }
  async getSessionsDataByWorkgroup(pageInfo) {
    const response = await ajaxService.postData(URL.allWorkGroupsDefaulUrl, pageInfo);
    store.dispatch("dsDashboard/setServiceSessionWorklistData", response);
  }
  getWorkgroupsList(pageInfo) {
    return ajaxService.postData(URL.dsDashBoardWorkgroupsListUrl, pageInfo);
  }
  searchSessionsDetails(searchBy) {
    return ajaxService.postData(URL.dsSearchUrl, searchBy);
  }
  searchRepairHistorySessionsData(searchBy) {
    return ajaxService.postData(URL.dsHistorySearchUrl, searchBy);
  }
  getdsAddInitInfo() {
    return ajaxService.get(URL.initAddDSUrl)
  }
  addDiagnosticSession(dsData) {
    return ajaxService.postData(URL.addDSIDUrl, dsData);
  }
  getModels() {
    return ajaxService.get(URL.attAutocompleteUrl)
  }
  isDisabledForProfile(profile) {
    return ajaxService.get(URL.isDsDisabledForProfile + profile);
   }
   getcloseCurrentDiagnosticSession() {
    return ajaxService.get(URL.closeCurrentDiagnosticSessionUrl);
   }

}
  

//------------------- DSDetailsService  -----------------------------------------
class DSDetailsService {

  getDSDetails(reqData) {
    return ajaxService.postData(URL.dsDetailsUrl, reqData);
  }
  getDSDetailsTabsContent(reqData) {
    return ajaxService.postData(URL.dsDetailsUrl, reqData);
  }
  addNotes(postData) {
    return ajaxService.postData(URL.dsDetailsAddNoteUrl, postData)
  }
  addAttachments(postData) {
    return ajaxService.postData(URL.dsDetailsAddAttachmentsUrl, postData)
  }
  dsAction(formData) {
    return ajaxService.postData(URL.dsDetailsUrl, formData);
  }
  dsCloseAction(postData) {
    return ajaxService.postData(URL.closeUrl, postData);
  }
  unlockDS(reqData) {
    return ajaxService.postData(URL.dsUnlockUrl, reqData);
  }
  renderShowCase(reqData) {
    return ajaxService.postData(URL.dsShowCaseUrl, reqData);
  }
  setStatus(formData) {
    return ajaxService.postData(URL.dsSetStatusUrl, formData);
  }
  // this method must be called after changing the owner property of the 
  // DS to actually perform the change
  changeOwner(dsid) {
    const formData = new FormData();
    formData.append("actionStartTime", new Date().getTime());
    formData.append("actionCategory", "DS");
    formData.append("actionEvent", "OWNER CHANGE");
    formData.append("actionValue", dsid);

    return ajaxService.postData(URL.callcenterUrl, formData)
  }
}

//---------------------------- Export Defaults  ---------------------------------------------------
export default { DSDashboardService: new DSDashboardService(), DSDetailsService: new DSDetailsService() };